"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _LinkTokenHelper = _interopRequireDefault(require("./helpers/LinkTokenHelper"));
var _LocalStorageHelpers = require("./helpers/LocalStorageHelpers");
var _PlaidHelper = require("./helpers/PlaidHelper");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Initializer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Initializer, _React$Component);
  var _super = _createSuper(Initializer);
  function Initializer(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Initializer);
    _this = _super.call(this, props);
    _this.state = {
      isButtonDisabled: false
    };
    _this.onHandleExit = _this.handleTokenExpiry.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onHandleSuccess = _this.handleSuccess.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onInitializePlaid = _this.InitializePlaid.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onFetchToken = _this.fetchToken.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(Initializer, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var receivedRedirectUri;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                receivedRedirectUri = this.props.config.receivedRedirectUri;
                if (receivedRedirectUri) {
                  this.onInitializePlaid((0, _LocalStorageHelpers.getLocalStorageLinkToken)());
                }
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "handleTokenExpiry",
    value: function () {
      var _handleTokenExpiry = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(err, metadata) {
        var error, _this$props, onExit, tokenUrl, tokenConfig, token;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                error = err;
                _this$props = this.props, onExit = _this$props.onExit, tokenUrl = _this$props.tokenUrl, tokenConfig = _this$props.tokenConfig;
                (0, _PlaidHelper.Destroy)();
                if (!(error && error.error_code === 'INVALID_LINK_TOKEN')) {
                  _context2.next = 10;
                  break;
                }
                _context2.next = 6;
                return (0, _LinkTokenHelper["default"])(true, tokenUrl, tokenConfig);
              case 6:
                token = _context2.sent;
                if (!token) {
                  error.lc_error = {
                    code: 'LINK_TOKEN_GENERATION_FAILED',
                    msg: "LC-PLAID-UI-COMPONENTS:: Link token generation failed"
                  };
                  this.setState(function () {
                    return {
                      isButtonDisabled: false
                    };
                  });
                  onExit(error);
                } else {
                  this.onInitializePlaid(token);
                }
                _context2.next = 12;
                break;
              case 10:
                this.setState(function () {
                  return {
                    isButtonDisabled: false
                  };
                });
                onExit(error, metadata);
              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function handleTokenExpiry(_x, _x2) {
        return _handleTokenExpiry.apply(this, arguments);
      }
      return handleTokenExpiry;
    }()
  }, {
    key: "handleSuccess",
    value: function () {
      var _handleSuccess = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(publicToken, metadata) {
        var onSuccess;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                onSuccess = this.props.onSuccess;
                _context3.next = 3;
                return this.setState(function () {
                  return {
                    isButtonDisabled: false
                  };
                });
              case 3:
                onSuccess(publicToken, metadata);
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function handleSuccess(_x3, _x4) {
        return _handleSuccess.apply(this, arguments);
      }
      return handleSuccess;
    }()
  }, {
    key: "InitializePlaid",
    value: function InitializePlaid(token) {
      var _this$props2 = this.props,
        env = _this$props2.env,
        onEvent = _this$props2.onEvent,
        receivedRedirectUri = _this$props2.config.receivedRedirectUri,
        clientName = _this$props2.tokenConfig.clientName;
      var plaidConfig = {
        env: env,
        token: token,
        onSuccess: this.onHandleSuccess,
        onExit: this.onHandleExit,
        onEvent: onEvent,
        clientName: clientName,
        receivedRedirectUri: receivedRedirectUri || null
      };
      (0, _PlaidHelper.Initialize)(plaidConfig, this.onHandleExit);
    }
  }, {
    key: "fetchToken",
    value: function () {
      var _fetchToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var _this$props3, tokenUrl, tokenConfig, onExit, token, error;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$props3 = this.props, tokenUrl = _this$props3.tokenUrl, tokenConfig = _this$props3.tokenConfig, onExit = _this$props3.onExit;
                this.setState(function () {
                  return {
                    isButtonDisabled: true
                  };
                });
                _context4.next = 4;
                return (0, _LinkTokenHelper["default"])(true, tokenUrl, tokenConfig);
              case 4:
                token = _context4.sent;
                if (!token) {
                  error = {
                    lc_error: {
                      code: 'LINK_TOKEN_GENERATION_FAILED',
                      msg: "LC-PLAID-UI-COMPONENTS:: Link token generation failed"
                    }
                  };
                  this.setState(function () {
                    return {
                      isButtonDisabled: false
                    };
                  });
                  onExit(error);
                } else {
                  this.onInitializePlaid(token);
                }
              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function fetchToken() {
        return _fetchToken.apply(this, arguments);
      }
      return fetchToken;
    }()
  }, {
    key: "renderDisabledButton",
    value: function renderDisabledButton(props, _onClick) {
      var _this2 = this;
      var isButtonDisabled = this.state.isButtonDisabled;
      return /*#__PURE__*/_react["default"].cloneElement(props.children, {
        onClick: function onClick(event) {
          event.preventDefault();
          _this2.onFetchToken();
          if (_onClick) _onClick();
        },
        disabled: isButtonDisabled
      });
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var onClick = props.onClick;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.renderDisabledButton(props, onClick));
    }
  }]);
  return Initializer;
}(_react["default"].Component);
Initializer.propTypes = {
  env: _propTypes.string.isRequired,
  onClick: _propTypes.func,
  onSuccess: _propTypes.func.isRequired,
  onEvent: _propTypes.func.isRequired,
  onExit: _propTypes.func.isRequired,
  tokenUrl: _propTypes.string.isRequired,
  tokenConfig: (0, _propTypes.shape)({
    clientName: _propTypes.string.isRequired,
    products: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
    user: (0, _propTypes.shape)({
      clientUserId: _propTypes.string.isRequired
    }).isRequired,
    redirectUri: _propTypes.string.isRequired
  }).isRequired,
  config: (0, _propTypes.shape)({
    receivedRedirectUri: _propTypes.string
  }).isRequired
};

/* istanbul ignore next */
Initializer.defaultProps = {
  onClick: function onClick() {}
};
var _default = Initializer;
exports["default"] = _default;
